// Utilities for European-style formatting (thousands '.' and decimal ',')

export function formatEuroNumber(value: number | null | undefined, decimals = 2): string {
  if (value === null || value === undefined || Number.isNaN(value) || !isFinite(value)) return '';
  try {
    const absDecimals = Math.max(0, decimals);
    const fixed = value.toFixed(absDecimals); // uses '.' as decimal
    const [intPartRaw, decPart] = fixed.split('.');
    const intWithDots = intPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return decPart !== undefined ? `${intWithDots},${decPart}` : intWithDots;
  } catch {
    return '';
  }
}

export function parseEuroNumber(text: string | null | undefined): number | null {
  if (!text) return null;
  const s = text.replace(/\./g, '').replace(',', '.').replace(/\s+/g, '').replace(/\u00A0/g, '');
  if (s === '' || s === '-') return null;
  const n = Number(s);
  return Number.isNaN(n) ? null : n;
}

export function formatEuroPercent(decimal: number | null | undefined, decimals = 2): string {
  if (decimal === null || decimal === undefined || Number.isNaN(decimal) || !isFinite(decimal)) return '';
  try {
    return `${formatEuroNumber(decimal * 100, decimals)}%`;
  } catch {
    return '';
  }
}

export function parseEuroPercent(text: string | null | undefined): number | null {
  if (!text) return null;
  const cleaned = text.replace('%', '');
  const num = parseEuroNumber(cleaned);
  if (num === null) return null;
  return num / 100; // return decimal for model
}

// Utilities for US-style formatting (thousands ',' and decimal '.')

export function formatUSNumber(value: number | null | undefined, decimals = 2): string {
  if (value === null || value === undefined || Number.isNaN(value) || !isFinite(value)) return '';
  try {
    const absDecimals = Math.max(0, decimals);
    const fixed = value.toFixed(absDecimals); // uses '.' as decimal
    const [intPartRaw, decPart] = fixed.split('.');
    const intWithCommas = intPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decPart !== undefined ? `${intWithCommas}.${decPart}` : intWithCommas;
  } catch {
    return '';
  }
}

export function parseUSNumber(text: string | null | undefined): number | null {
  if (!text) return null;
  const s = text.replace(/,/g, '').replace(/\s+/g, '').replace(/\u00A0/g, '');
  if (s === '' || s === '-') return null;
  const n = Number(s);
  return Number.isNaN(n) ? null : n;
}

export function formatUSPercent(decimal: number | null | undefined, decimals = 2): string {
  if (decimal === null || decimal === undefined || Number.isNaN(decimal) || !isFinite(decimal)) return '';
  try {
    return `${formatUSNumber(decimal * 100, decimals)}%`;
  } catch {
    return '';
  }
}

export function parseUSPercent(text: string | null | undefined): number | null {
  if (!text) return null;
  const cleaned = text.replace('%', '');
  const num = parseUSNumber(cleaned);
  if (num === null) return null;
  return num / 100; // return decimal for model
}

